import { SEND_RATE_CONFIGS_SUCCESS, SEND_RATE_CONFIGS_REQUEST, SEND_RATE_CONFIGS_FAILURE, SEND_RATE_CONFIGS_REST } from "@/redux/actions/RateManagement/SendRateConfigs";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const sendRateConfigsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_RATE_CONFIGS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case SEND_RATE_CONFIGS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case SEND_RATE_CONFIGS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case SEND_RATE_CONFIGS_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default sendRateConfigsReducer;
